export default __webpack_public_path__ + "static/1-c69526b89000704f1200838841be2a58.jpg";